webpackJsonp([1],{

/***/ "/EWK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Ogx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "2ZkL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3qCH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5IE1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6cjY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7M5x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C/NM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HVqO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K3jJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M9V4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/css/reset.css
var css_reset = __webpack_require__("xsZ7");
var reset_default = /*#__PURE__*/__webpack_require__.n(css_reset);

// EXTERNAL MODULE: ./src/css/base.css
var base = __webpack_require__("dNEa");
var base_default = /*#__PURE__*/__webpack_require__.n(base);

// EXTERNAL MODULE: ./src/css/badge.css
var badge = __webpack_require__("pz9T");
var badge_default = /*#__PURE__*/__webpack_require__.n(badge);

// EXTERNAL MODULE: ./src/css/breadcrumb.css
var breadcrumb = __webpack_require__("S4k7");
var breadcrumb_default = /*#__PURE__*/__webpack_require__.n(breadcrumb);

// EXTERNAL MODULE: ./src/css/button.css
var css_button = __webpack_require__("tYzW");
var button_default = /*#__PURE__*/__webpack_require__.n(css_button);

// EXTERNAL MODULE: ./src/css/filter.css
var filter = __webpack_require__("mYAJ");
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);

// EXTERNAL MODULE: ./src/css/form.css
var css_form = __webpack_require__("HVqO");
var form_default = /*#__PURE__*/__webpack_require__.n(css_form);

// EXTERNAL MODULE: ./src/css/grid.css
var grid = __webpack_require__("6cjY");
var grid_default = /*#__PURE__*/__webpack_require__.n(grid);

// EXTERNAL MODULE: ./src/css/header.css
var header = __webpack_require__("2ZkL");
var header_default = /*#__PURE__*/__webpack_require__.n(header);

// EXTERNAL MODULE: ./src/css/item.css
var item = __webpack_require__("5IE1");
var item_default = /*#__PURE__*/__webpack_require__.n(item);

// EXTERNAL MODULE: ./src/css/overlay.css
var overlay = __webpack_require__("M9V4");
var overlay_default = /*#__PURE__*/__webpack_require__.n(overlay);

// EXTERNAL MODULE: ./src/css/row.css
var row = __webpack_require__("OHVl");
var row_default = /*#__PURE__*/__webpack_require__.n(row);

// EXTERNAL MODULE: ./src/css/search.css
var search = __webpack_require__("3qCH");
var search_default = /*#__PURE__*/__webpack_require__.n(search);

// EXTERNAL MODULE: ./src/css/share.css
var share = __webpack_require__("yg31");
var share_default = /*#__PURE__*/__webpack_require__.n(share);

// EXTERNAL MODULE: ./src/css/splash.css
var splash = __webpack_require__("7M5x");
var splash_default = /*#__PURE__*/__webpack_require__.n(splash);

// EXTERNAL MODULE: ./src/css/tabs.css
var tabs = __webpack_require__("K3jJ");
var tabs_default = /*#__PURE__*/__webpack_require__.n(tabs);

// EXTERNAL MODULE: ./src/css/tag.css
var css_tag = __webpack_require__("/Ogx");
var tag_default = /*#__PURE__*/__webpack_require__.n(css_tag);

// EXTERNAL MODULE: ./src/css/votes.css
var votes = __webpack_require__("pb+Z");
var votes_default = /*#__PURE__*/__webpack_require__.n(votes);

// EXTERNAL MODULE: ./src/css/image.css
var css_image = __webpack_require__("r/Sp");
var image_default = /*#__PURE__*/__webpack_require__.n(css_image);

// EXTERNAL MODULE: ./src/css/text.css
var css_text = __webpack_require__("Su43");
var text_default = /*#__PURE__*/__webpack_require__.n(css_text);

// EXTERNAL MODULE: ./src/css/checkbox.css
var css_checkbox = __webpack_require__("C/NM");
var checkbox_default = /*#__PURE__*/__webpack_require__.n(css_checkbox);

// EXTERNAL MODULE: ./node_modules/whatwg-fetch/fetch.js
var whatwg_fetch_fetch = __webpack_require__("rplX");
var fetch_default = /*#__PURE__*/__webpack_require__.n(whatwg_fetch_fetch);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/set.js
var set = __webpack_require__("lHA8");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Loader.vue
//
//
//
//
//
//
//

/* harmony default export */ var Loader = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-862d33a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
var Loader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"cube1"}),_vm._v(" "),_c('div',{staticClass:"cube2"})])}]
var esExports = { render: Loader_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Loader = (esExports);
// CONCATENATED MODULE: ./src/components/Loader.vue
function injectStyle (ssrContext) {
  __webpack_require__("/EWK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Loader,
  components_Loader,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Loader = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./src/util/request.js




var request__this = this;

var mode = 'cors';
var headers = {
  'access-token': "5d906f1cf43d871509a2ff246baffbd461429559ba1fa37b70fe8616e6fe68de",
  Accept: 'application/vnd.' + "radioring_api" + '.api+json;version=v' + Object({"NODE_ENV":"production","APP_NAME":"radioring_api","CDN_DOMAIN":"https://d2gg2n9hjjjmhb.cloudfront.net","API_DOMAIN":"https://radioring-api.abcvoting.com","FRONTEND_DOMAIN":"https://radioring.avrotros.nl","ACCESS_TOKEN":"5d906f1cf43d871509a2ff246baffbd461429559ba1fa37b70fe8616e6fe68de","CAPTCHA_KEY":"6LegDn4UAAAAABDiXFEZIIWVp6-zmbigNVXeUVxC","AT_INTERNET_SITE_ID":595271}).API_VERSION
};

var get = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(endpoint) {
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("https://radioring-api.abcvoting.com" + '/' + endpoint, {
              headers: headers
            });

          case 2:
            return _context.abrupt('return', _context.sent);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, request__this);
  }));

  return function get(_x) {
    return _ref.apply(this, arguments);
  };
}();

var request_post = function post(endpoint) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var body = new FormData();

  keys_default()(data).forEach(function (key) {
    body.append(key, data[key]);
  });

  return fetch("https://radioring-api.abcvoting.com" + '/' + endpoint, {
    mode: mode,
    headers: headers,
    body: body,
    method: 'POST'
  });
};
// CONCATENATED MODULE: ./src/sortTypes.js
var SORT_ASC = 0;
var SORT_DESC = 1;
var SORT_RANDOM = 2;
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var CDN_DOMAIN = "https://d2gg2n9hjjjmhb.cloudfront.net";


/* harmony default export */ var App = ({
  name: 'app',
  components: {
    loader: src_components_Loader
  },
  computed: {
    loaded: function loaded() {
      return this.$store.state.loaded;
    },
    offline: function offline() {
      return this.$store.state.offline;
    },
    offlineDescription: function offlineDescription() {
      return this.$store.state.frontend.offline_description ? this.$store.state.frontend.offline_description : 'Er kan momenteel niet gestemd worden.';
    }
  },
  mounted: function mounted() {
    var _this = this;

    get('frontend').then(function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(response) {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return response.json();

              case 2:
                return _context.abrupt('return', _context.sent);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()).then(function (response) {
      var data = response.data;
      var imageSrc = data.image ? data.image.data.src : null;
      var seoImageSrc = data.seoImage ? data.seoImage.data.src : null;

      var frontend = {
        description: data.description,
        offline_description: data.offline_description,
        image: imageSrc ? CDN_DOMAIN + imageSrc : null,
        seoName: data.seoName,
        seoDescription: data.seoDescription,
        seoImage: seoImageSrc ? CDN_DOMAIN + seoImageSrc : null
      };
      _this.$store.dispatch('setFrontend', frontend);
    });

    get('voting/round').then(function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(response) {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return response.json();

              case 2:
                return _context2.abrupt('return', _context2.sent);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()).then(function (response) {
      var round = response.data;

      if (!round) {
        _this.$store.dispatch('setOffline', true);
        return;
      }
      _this.$store.dispatch('setAllowSuggestions', round.allow_suggestions && round.suggestions_max > 0);
      var categoriesOrderedByName = values_default()(round.categories.data || {}).map(function (_ref3) {
        var id = _ref3.id,
            name = _ref3.name;

        return {
          id: Number(id),
          name: name,
          slug: name.replace(' ', '-').toLowerCase(),
          sortType: SORT_RANDOM,
          selectedChannelId: null,
          selectedDayPartId: null,
          keyword: ''
        };
      }).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });

      var categoryId = categoriesOrderedByName.map(function (obj) {
        return obj.id;
      }).reverse();

      var categoriesOrderedById = categoryId.map(function (id) {
        return categoriesOrderedByName.find(function (category) {
          return category.id === id;
        });
      }).filter(function (x) {
        return x;
      });

      var categories = categoriesOrderedById.length === 3 ? categoriesOrderedById : categoriesOrderedByName;

      var categoriesArray = categories.map(function (obj) {
        return obj.id;
      });

      var stationsTags = categoriesArray.reduce(function (acc, num) {
        acc[num] = [];
        return acc;
      }, {});

      var nominees = values_default()(round.nominees.data || {}).map(function (nominee) {
        var imageSrc = nominee.image ? nominee.image.data.src : null;
        var imageThumnb = nominee.image ? nominee.image.data.src : null;

        if (categoriesArray.includes(nominee.category_id)) {
          if (nominee.zender1 !== null) {
            stationsTags[nominee.category_id].push(nominee.zender1);
          }
          if (nominee.zender2 !== null) {
            stationsTags[nominee.category_id].push(nominee.zender2);
          }
        }

        var showtimesKeys = ['ochtend', 'middag', 'avond', 'nacht', 'weekend'];
        var showtimesKeyMapping = {
          o: 'ochtend',
          m: 'middag',
          a: 'avond',
          n: 'nacht',
          w: 'weekend'
        };
        var showtimes = entries_default()(nominee).filter(function (_ref4) {
          var _ref5 = slicedToArray_default()(_ref4, 2),
              key = _ref5[0],
              value = _ref5[1];

          return showtimesKeyMapping[key] && value !== 0 && showtimesKeys.includes(showtimesKeyMapping[key]);
        }).map(function (_ref6) {
          var _ref7 = slicedToArray_default()(_ref6, 1),
              key = _ref7[0];

          return defineProperty_default()({}, showtimesKeys.indexOf(showtimesKeyMapping[key]), showtimesKeyMapping[key]);
        });

        return {
          id: nominee.id,
          name: nominee.name,
          slug: nominee.name.replace(/[^a-zA-Z ]/g, '').toLowerCase().replace(/ /g, '-'),
          secondaryName: nominee.secondary_name,
          categoryId: nominee.category_id,
          combinedName: nominee.combined_name,
          image: imageSrc ? CDN_DOMAIN + imageSrc.replace('//d2gg2n9hjjjmhb.cloudfront.net/', '') : null,
          imageThumb: imageThumnb ? CDN_DOMAIN + imageThumnb.replace('//d2gg2n9hjjjmhb.cloudfront.net/', '') : null,
          stations: [nominee.zender1, nominee.zender2].filter(function (item) {
            return item !== null && item !== '';
          }),
          broadcaster: nominee.omroep,
          showtimes: showtimes
        };
      });
      categoriesArray.forEach(function (property) {
        stationsTags[property] = [].concat(toConsumableArray_default()(new set_default.a(stationsTags[property]))).filter(function (item) {
          return item !== null && item !== '';
        });
      });
      _this.$store.dispatch('setStationsTags', stationsTags);
      _this.$store.dispatch('setRounds', round);
      _this.$store.dispatch('setCategories', categories);
      _this.$store.dispatch('setNominees', nominees);
      _this.$store.dispatch('setLoaded', true);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14869f04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app__background",attrs:{"id":"app"}},[_c('header',{staticClass:"header"},[_c('router-link',{staticClass:"logo--avrotros",attrs:{"to":{ name: 'splash' }}},[_vm._v("\n      AVROTROS\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"logo--radioring",attrs:{"to":{ name: 'splash' }}},[_vm._v("\n      RadioRing\n    ")])],1),_vm._v(" "),(_vm.loaded)?_c('router-view'):(_vm.offline)?_c('p',{staticClass:"p--md",staticStyle:{"text-align":"center"},domProps:{"innerHTML":_vm._s(_vm.offlineDescription)}}):_c('loader')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = null
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Splash.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Splash = ({
  name: 'Splash',
  computed: {
    round: function round() {
      return this.$store.state.rounds;
    },
    frontend: function frontend() {
      return this.$store.state.frontend;
    },
    hasRound: function hasRound() {
      return typeof_default()(this.round) === 'object';
    },
    categories: function categories() {
      return this.round.categories.data;
    },
    category: function category() {
      return this.categories[0];
    },
    hasSingleCategory: function hasSingleCategory() {
      return this.round.categories.data.length >= 1;
    },
    styles: function styles() {
      return this.hasRound && this.round.image ? {
        backgroundImage: 'url(' + this.round.image + ')'
      } : {};
    }
  },
  methods: {
    urlForCategory: function urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categoryId: category.id
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-217679cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Splash.vue
var Splash_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash"},[(_vm.hasRound)?_c('div',{staticClass:"splash__body"},[_c('div',{staticClass:"imageContainer"},[_c('img',{staticClass:"splash__image",attrs:{"src":"/static/AT_RadioRing_C.jpeg","alt":"Radioring"}}),_vm._v(" "),(!_vm.hasSingleCategory)?_c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('button',{staticClass:"main-button"},[_vm._v("\n         Website\n        ")])]):_vm._e(),_vm._v(" "),(_vm.hasSingleCategory)?_c('router-link',{attrs:{"to":_vm.urlForCategory(_vm.category)}},[_c('button',{staticClass:"main-button"},[_vm._v("\n          Stem nu\n        ")])]):_vm._e()],1)]):_c('div',{staticClass:"message-container"},[_c('b',{staticStyle:{"font-size":"large"}},[_vm._v("Het is momenteel niet mogelijk om te stemmen.")])]),_vm._v(" "),(_vm.frontend.description)?_c('div',{staticClass:"container--border p--lg",staticStyle:{"text-align":"left","font-size":"100%"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.frontend.description)}})]):_vm._e()])}
var Splash_staticRenderFns = []
var Splash_esExports = { render: Splash_render, staticRenderFns: Splash_staticRenderFns }
/* harmony default export */ var components_Splash = (Splash_esExports);
// CONCATENATED MODULE: ./src/components/Splash.vue
function Splash_injectStyle (ssrContext) {
  __webpack_require__("YI7j")
}
var Splash_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Splash___vue_template_functional__ = false
/* styles */
var Splash___vue_styles__ = Splash_injectStyle
/* scopeId */
var Splash___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Splash___vue_module_identifier__ = null
var Splash_Component = Splash_normalizeComponent(
  Splash,
  components_Splash,
  Splash___vue_template_functional__,
  Splash___vue_styles__,
  Splash___vue_scopeId__,
  Splash___vue_module_identifier__
)

/* harmony default export */ var src_components_Splash = (Splash_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue

//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Home = ({
  name: 'Home',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(['categories']), Object(vuex_esm["b" /* mapGetters */])(['selection'])),
  methods: {
    urlForCategory: function urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categoryId: category.id
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eaa3be8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home--view"},_vm._l((_vm.categories),function(category){return _c('router-link',{key:category.id,staticClass:"home--background",attrs:{"to":_vm.urlForCategory(category)}},[_vm._v("\n    "+_vm._s(category.name)+"\n  ")])}),1)}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var components_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/Home.vue
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = null
/* scopeId */
var Home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  components_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_components_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./src/util/inViewport.js
var _document = document,
    documentElement = _document.documentElement;


var inViewport = function inViewport(el) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : documentElement;

  var elRect = el.getBoundingClientRect();
  var viewport = {};
  if (container === documentElement) {
    viewport = {
      top: -offset,
      left: -offset,
      right: documentElement.clientWidth + offset,
      bottom: documentElement.clientHeight + offset
    };
  } else {
    var containerRect = container.getBoundingClientRect();
    viewport = {
      top: containerRect.top - offset,
      left: containerRect.left - offset,
      right: containerRect.right + offset,
      bottom: containerRect.bottom + offset
    };
  }

  return elRect.right >= viewport.left && elRect.left <= viewport.right && elRect.bottom >= viewport.top && elRect.top <= viewport.bottom;
};

/* harmony default export */ var util_inViewport = (inViewport);
// CONCATENATED MODULE: ./src/util/throttle.js
var throttle = function throttle(fn) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var last = 0;
  var deferTimer = null;
  return function () {
    var context = scope || this;
    var now = Date.now();
    var args = arguments;
    if (last && now < last + threshold) {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
};

/* harmony default export */ var util_throttle = (throttle);
// CONCATENATED MODULE: ./src/util/listen.js
var listen = function listen(el, event, callback) {
  el.addEventListener(event, callback);
  return function () {
    el.removeEventListener(event, callback);
  };
};

/* harmony default export */ var util_listen = (listen);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NomineeItem.vue
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var NomineeItem = ({
  name: 'NomineeItem',
  props: {
    nominee: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      inViewport: false,
      listeners: []
    };
  },

  methods: {
    checkIfInViewport: function checkIfInViewport() {
      var _this = this;

      if (util_inViewport(this.$el, 10)) {
        var image = new Image();
        image.onload = function () {
          _this.inViewport = true;
        };
        image.src = this.nominee.image;

        this.stopChecking();
      }
    },
    startChecking: function startChecking() {
      var checkIfInViewport = util_throttle(this.checkIfInViewport, 100);

      this.listeners = [util_listen(window, 'resize', checkIfInViewport), util_listen(document, 'scroll', checkIfInViewport)];
    },
    stopChecking: function stopChecking() {
      this.listeners.forEach(function (unlisten) {
        return unlisten();
      });
      this.listeners = [];
    }
  },

  mounted: function mounted() {
    this.startChecking();
    this.checkIfInViewport();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopChecking();
  },


  computed: {
    ready: function ready() {
      return this.inViewport && this.nominee.image;
    },
    classes: function classes() {
      return {
        item__body: true,
        'item__body--loaded': this.ready
      };
    },
    styles: function styles() {
      return this.ready ? {
        backgroundImage: 'url(' + this.nominee.image + ')'
      } : {};
    },
    url: function url() {
      return {
        name: 'nominee',
        params: {
          categorySlug: this.category.slug,
          nomineeId: this.nominee.id,
          nomineeSlug: this.nominee.slug
        }
      };
    },
    channelTags: function channelTags() {
      return this.nominee.showtimes;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-914b5552","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NomineeItem.vue
var NomineeItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.url}},[_c('div',{class:_vm.classes,style:(_vm.styles)}),_vm._v(" "),_c('h3',[_vm._v("\n    "+_vm._s(_vm.nominee.name)+" "),_c('br'),_vm._v("\n    "+_vm._s(_vm.nominee.stations[0])+"\n  ")])])}
var NomineeItem_staticRenderFns = []
var NomineeItem_esExports = { render: NomineeItem_render, staticRenderFns: NomineeItem_staticRenderFns }
/* harmony default export */ var components_NomineeItem = (NomineeItem_esExports);
// CONCATENATED MODULE: ./src/components/NomineeItem.vue
var NomineeItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NomineeItem___vue_template_functional__ = false
/* styles */
var NomineeItem___vue_styles__ = null
/* scopeId */
var NomineeItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NomineeItem___vue_module_identifier__ = null
var NomineeItem_Component = NomineeItem_normalizeComponent(
  NomineeItem,
  components_NomineeItem,
  NomineeItem___vue_template_functional__,
  NomineeItem___vue_styles__,
  NomineeItem___vue_scopeId__,
  NomineeItem___vue_module_identifier__
)

/* harmony default export */ var src_components_NomineeItem = (NomineeItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NomineeModal.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var MIN_HEIGHT = 490;
var NomineeModal__document = document,
    NomineeModal_documentElement = NomineeModal__document.documentElement;


/* harmony default export */ var NomineeModal = ({
  name: 'Nominee',
  props: {
    categoryId: {
      type: Number,
      required: true
    },
    nomineeId: {
      type: Number,
      required: true
    },
    filteredNominees: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      imageLoaded: false,
      listeners: [],
      minHeight: MIN_HEIGHT,
      windowHeight: window.innerHeight
    };
  },

  watch: {
    nomineeId: function nomineeId() {
      this.determineImageUrl();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.determineImageUrl();

    var detectWindowHeight = util_throttle(function () {
      _this.windowHeight = window.innerHeight;
    }, 500);

    this.listeners = [util_listen(window, 'keyup', this.onKeyUp), util_listen(window, 'resize', detectWindowHeight)];

    NomineeModal_documentElement.classList.add('no-scroll');
  },
  beforeDestroy: function beforeDestroy() {
    this.listeners.forEach(function (unlisten) {
      return unlisten();
    });
    NomineeModal_documentElement.classList.remove('no-scroll');
  },

  methods: {
    onKeyUp: function onKeyUp(e) {
      if (e.keyCode === 39) {
        if (this.nextNominee) {
          this.$router.push(this.urlForNominee(this.nextNominee));
        }
      } else if (e.keyCode === 37) {
        if (this.prevNominee) {
          this.$router.push(this.urlForNominee(this.prevNominee));
        }
      } else if (e.keyCode === 27) {
        this.closeModal();
      }
    },
    determineImageUrl: function determineImageUrl() {
      var _this2 = this;

      this.imageLoaded = false;

      var image = new Image();
      image.onload = function () {
        _this2.imageLoaded = true;
      };

      image.src = this.nominee.image;
    },
    selectNominee: function selectNominee() {
      var categoryId = this.categoryId,
          nomineeId = this.nomineeId;

      this.$store.dispatch('selectNominee', { categoryId: categoryId, nomineeId: nomineeId });
      this.closeModal();
    },
    moveToSubmit: function moveToSubmit() {
      this.$router.push({ name: 'submit' });
    },
    closeModal: function closeModal() {
      this.$router.push(this.urlForCategory(this.category));
    },
    urlForCategory: function urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categorySlug: category.slug
        }
      };
    },
    urlForNominee: function urlForNominee(nominee) {
      return {
        name: 'nominee',
        params: {
          categorySlug: this.category.slug,
          nomineeId: nominee.id,
          nomineeSlug: nominee.slug
        }
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(['selected', 'categories']), {
    category: function category() {
      var _this3 = this;

      return this.categories.find(function (_ref) {
        var id = _ref.id;
        return id === _this3.categoryId;
      });
    },
    twitter: function twitter() {
      var hashtag = this.nominee.hashtag;


      if (hashtag && hashtag.length) {
        return 'https://twitter.com/' + hashtag.substr(1);
      }

      return null;
    },
    instagram: function instagram() {
      var hometown = this.nominee.hometown;


      if (hometown && hometown.length) {
        return 'https://instagram.com/' + hometown.substr(1);
      }

      return null;
    },
    hasSelectedNominee: function hasSelectedNominee() {
      var _this4 = this;

      return this.selected.find(function (_ref2) {
        var categoryId = _ref2.categoryId;
        return categoryId === _this4.category.id;
      });
    },
    nominees: function nominees() {
      return this.$store.getters.getNomineesByCategoryId(this.categoryId);
    },
    nomineeIndex: function nomineeIndex() {
      var _this5 = this;

      return this.filteredNominees.findIndex(function (_ref3) {
        var id = _ref3.id;
        return id === _this5.nomineeId;
      });
    },
    prevNominee: function prevNominee() {
      var prevIndex = this.nomineeIndex - 1;
      return this.filteredNominees[prevIndex];
    },
    nextNominee: function nextNominee() {
      var nextIndex = this.nomineeIndex + 1;
      return this.filteredNominees[nextIndex];
    },
    imageUrl: function imageUrl() {
      return this.imageLoaded ? this.nominee.image : this.nominee.imageThumb;
    },
    nominee: function nominee() {
      var _this6 = this;

      return this.nominees.find(function (_ref4) {
        var id = _ref4.id;
        return id === _this6.nomineeId;
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03d3ed2d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NomineeModal.vue
var NomineeModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.nominee && _vm.category)?_c('div',[_c('div',{staticClass:"overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.closeModal.apply(null, arguments)}}},[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__head"},[_c('p',[_c('b',[_vm._v("\n            "+_vm._s(_vm.category.name)+"\n          ")])]),_vm._v(" "),_c('span',{staticClass:"modal__close",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fa fa-lg fa-close",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"modal__image"},[(_vm.imageUrl)?_c('img',{attrs:{"src":_vm.imageUrl,"onerror":"this.src='static/rr_fallback.png';"}}):_c('img',{attrs:{"src":"static/rr_fallback.png"}}),_vm._v(" "),(this.prevNominee)?_c('router-link',{staticClass:"modal__left",attrs:{"title":this.prevNominee.name,"to":_vm.urlForNominee(this.prevNominee)}},[_c('i',{staticClass:"fa fa-lg fa-chevron-left"})]):_vm._e(),_vm._v(" "),(this.nextNominee)?_c('router-link',{staticClass:"modal__right",attrs:{"title":this.nextNominee.name,"to":_vm.urlForNominee(this.nextNominee)}},[_c('i',{staticClass:"fa fa-lg fa-chevron-right"})]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"modal__body"},[_c('h2',[_vm._v(_vm._s(_vm.nominee.name))]),_vm._v(" "),_vm._l((_vm.nominee.stations),function(station){return _c('h3',[_vm._v(_vm._s(station)+" "),(_vm.nominee.broadcaster)?_c('label',[_vm._v("("+_vm._s(_vm.nominee.broadcaster)+")")]):_vm._e()])}),_vm._v(" "),(_vm.twitter)?_c('p',[_vm._v("\n          Twitter:\n          "),_c('a',{attrs:{"href":_vm.twitter,"target":"_blank"}},[_vm._v("\n            "+_vm._s(_vm.nominee.hashtag)+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.instagram)?_c('p',[_vm._v("\n          Instagram:\n          "),_c('a',{attrs:{"href":_vm.instagram,"target":"_blank"}},[_vm._v("\n            "+_vm._s(_vm.nominee.hometown)+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.nominee.secondaryName && _vm.windowHeight >= _vm.minHeight)?_c('p',[_vm._v("\n          "+_vm._s(_vm.nominee.secondaryName)+"\n\n          "),(_vm.nominee.knownFor)?_c('small',[_vm._v("| "+_vm._s(_vm.nominee.knownFor))]):_vm._e()]):_vm._e()],2),_vm._v(" "),_c('div',{class:{
          'p--lg': _vm.windowHeight >= _vm.minHeight,
          'p--md': _vm.windowHeight < _vm.minHeight
        }},[(!_vm.hasSelectedNominee)?_c('button',{staticClass:"button button--fullwidth button--modal",on:{"click":function($event){$event.stopPropagation();return _vm.selectNominee.apply(null, arguments)}}},[_vm._v("\n          Kies\n        ")]):_vm._e()])])])]):_vm._e()}
var NomineeModal_staticRenderFns = []
var NomineeModal_esExports = { render: NomineeModal_render, staticRenderFns: NomineeModal_staticRenderFns }
/* harmony default export */ var components_NomineeModal = (NomineeModal_esExports);
// CONCATENATED MODULE: ./src/components/NomineeModal.vue
var NomineeModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NomineeModal___vue_template_functional__ = false
/* styles */
var NomineeModal___vue_styles__ = null
/* scopeId */
var NomineeModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NomineeModal___vue_module_identifier__ = null
var NomineeModal_Component = NomineeModal_normalizeComponent(
  NomineeModal,
  components_NomineeModal,
  NomineeModal___vue_template_functional__,
  NomineeModal___vue_styles__,
  NomineeModal___vue_scopeId__,
  NomineeModal___vue_module_identifier__
)

/* harmony default export */ var src_components_NomineeModal = (NomineeModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SuggestionModal.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var SuggestionModal_MIN_HEIGHT = 490;
var SuggestionModal__document = document,
    SuggestionModal_documentElement = SuggestionModal__document.documentElement;


/* harmony default export */ var SuggestionModal = ({
  name: 'Suggestion',
  props: {
    categoryId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      listeners: [],
      minHeight: SuggestionModal_MIN_HEIGHT,
      windowHeight: window.innerHeight,
      suggestionName: null,
      suggestionStation: null,
      stations: ['100%NL', 'BNR Nieuwsradio', 'Groot Nieuws Radio', 'JOE', 'KINK', 'NPO 3FM', 'NPO Klassiek', 'NPO Radio 1', 'NPO Radio 2', 'NPO Radio 5', 'Qmusic', 'Radio 10', 'Radio 538', 'Radio Decibel', 'Radio Veronica', 'RadioNL', 'SLAM!', 'SterrenNL', 'Sublime']
    };
  },
  mounted: function mounted() {
    var _this = this;

    var detectWindowHeight = util_throttle(function () {
      _this.windowHeight = window.innerHeight;
    }, 500);

    this.listeners = [util_listen(window, 'keyup', this.onKeyUp), util_listen(window, 'resize', detectWindowHeight)];

    SuggestionModal_documentElement.classList.add('no-scroll');
  },
  beforeDestroy: function beforeDestroy() {
    this.listeners.forEach(function (unlisten) {
      return unlisten();
    });
    SuggestionModal_documentElement.classList.remove('no-scroll');
  },

  methods: {
    submit: function submit() {
      if (this.isValid()) {
        this.addSuggestion();
      }
    },
    onKeyUp: function onKeyUp(e) {
      if (e.keyCode === 27) {
        this.$emit('closeModal');
      }
    },
    isValid: function isValid() {
      var hasSuggestion = this.suggestionName && this.suggestionName.trim().length > 0;
      var hasStation = this.category.name.toLowerCase() === 'podcast' || this.stations.includes(this.suggestionStation);
      return hasSuggestion && hasStation;
    },
    isIncomplete: function isIncomplete() {
      return !this.isValid();
    },
    addSuggestion: function addSuggestion() {
      var categoryId = this.categoryId,
          suggestionName = this.suggestionName,
          suggestionStation = this.suggestionStation;


      this.$store.dispatch('addSuggestion', {
        categoryId: categoryId,
        suggestionName: suggestionName,
        suggestionStation: suggestionStation
      });

      this.$emit('closeModal');
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(['selected', 'categories']), {
    category: function category() {
      var _this2 = this;

      return this.categories.find(function (_ref) {
        var id = _ref.id;
        return id === _this2.categoryId;
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27ccb3da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SuggestionModal.vue
var SuggestionModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.category)?_c('div',[_c('div',{staticClass:"overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.$emit('closeModal')}}},[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__head"},[_c('p',[_vm._v("\n          "+_vm._s(_vm.category.name)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"modal__close",on:{"click":function($event){return _vm.$emit('closeModal')}}},[_c('i',{staticClass:"fa fa-lg fa-close",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"modal__body"},[_c('p',{staticClass:"mb--lg"},[_c('strong',[_vm._v("\n            Voeg je eigen suggestie toe voor de categorie '"+_vm._s(_vm.category.name.toLowerCase())+"'.")])]),_vm._v(" "),[(_vm.category.name.toLowerCase() === 'man' || _vm.category.name.toLowerCase() === 'vrouw')?_c('p',[_vm._v("\n            Wat is de naam van de persoon?\n          ")]):(_vm.category.name.toLowerCase() === 'programma')?_c('p',[_vm._v("\n            Wat is de naam van het programma?\n          ")]):(_vm.category.name.toLowerCase() === 'podcast')?_c('p',[_vm._v("\n            Wat is de naam van de podcast?\n          ")]):(_vm.category.name.toLowerCase() === 'presentator')?_c('p',[_vm._v("\n            Wat is de naam van de presentator?\n          ")]):_c('p',[_vm._v("\n            Wat is de naam van het programma?\n          ")])],_vm._v(" "),_c('form',{ref:"form",staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"form__field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.suggestionName),expression:"suggestionName"}],staticClass:"form__input mt--md",attrs:{"type":"text","required":"","placeholder":"Naam *","id":"form__field_name"},domProps:{"value":(_vm.suggestionName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.suggestionName=$event.target.value}}})]),_vm._v(" "),(_vm.category.name.toLowerCase() !== 'podcast')?[_c('p',{staticClass:"mt--md"},[_vm._v("\n              Bij welk radiostation behoort je suggestie?\n            ")]),_vm._v(" "),_c('div',{staticClass:"form__field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.suggestionStation),expression:"suggestionStation"}],staticClass:"form__input form__input--select mt--md",attrs:{"required":"","id":"form__field_station"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.suggestionStation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("Selecteer een radiostation")]),_vm._v(" "),_vm._l((_vm.stations),function(station,index){return _c('option',{key:("station-" + index),domProps:{"value":station}},[_vm._v("\n                  "+_vm._s(station)+"\n                ")])})],2)])]:_vm._e()],2)],2),_vm._v(" "),_c('div',{class:{
          'p--lg': _vm.windowHeight >= _vm.minHeight,
          'p--md': _vm.windowHeight < _vm.minHeight
        }},[_c('button',{staticClass:"button button--fullwidth",attrs:{"disabled":_vm.isIncomplete()},on:{"click":function($event){$event.preventDefault();return _vm.addSuggestion.apply(null, arguments)}}},[_vm._v("\n          Voeg suggestie toe\n        ")])])])])]):_vm._e()}
var SuggestionModal_staticRenderFns = []
var SuggestionModal_esExports = { render: SuggestionModal_render, staticRenderFns: SuggestionModal_staticRenderFns }
/* harmony default export */ var components_SuggestionModal = (SuggestionModal_esExports);
// CONCATENATED MODULE: ./src/components/SuggestionModal.vue
var SuggestionModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SuggestionModal___vue_template_functional__ = false
/* styles */
var SuggestionModal___vue_styles__ = null
/* scopeId */
var SuggestionModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SuggestionModal___vue_module_identifier__ = null
var SuggestionModal_Component = SuggestionModal_normalizeComponent(
  SuggestionModal,
  components_SuggestionModal,
  SuggestionModal___vue_template_functional__,
  SuggestionModal___vue_styles__,
  SuggestionModal___vue_scopeId__,
  SuggestionModal___vue_module_identifier__
)

/* harmony default export */ var src_components_SuggestionModal = (SuggestionModal_Component.exports);

// CONCATENATED MODULE: ./src/util/triggerResize.js


var triggerResize_triggerResize = function triggerResize() {
  vue_esm["a" /* default */].nextTick(function () {
    if (window.dispatchEvent && window.Event) {
      window.dispatchEvent(new Event('resize'));
    } else if (window.document.createEvent) {
      var resizeEvent = window.document.createEvent('UIEvents');
      resizeEvent.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(resizeEvent);
    }
  });
};

/* harmony default export */ var util_triggerResize = (triggerResize_triggerResize);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Category.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var HYPHENATE_AT = 11;
var HAS_TOUCH = 'ontouchstart' in document.documentElement;
var IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var IS_IOS_SMALL = /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
// iOS has issues with the virtual keyboard overlapping the input
var SEARCH_FIXED = HAS_TOUCH && !IS_IOS;

var sortTypes = [{ type: SORT_ASC, icon: 'fa-long-arrow-down', title: 'Oplopend' }, { type: SORT_DESC, icon: 'fa-long-arrow-up', title: 'Aflopend' }, { type: SORT_RANDOM, icon: 'fa-random', title: 'Willekeurig' }];

/* harmony default export */ var Category = ({
  name: 'Category',
  props: {
    categoryId: {
      type: Number,
      required: true
    },
    nomineeId: {
      type: Number,
      required: false
    }
  },
  data: function data() {
    return {
      hasTouch: HAS_TOUCH,
      isIOS: IS_IOS,
      isIOSSmall: IS_IOS_SMALL,
      searchFixed: SEARCH_FIXED,
      sortTypes: sortTypes,
      showSuggestionModal: false,
      showFilters: false
    };
  },

  components: {
    'nominee-modal': src_components_NomineeModal,
    'suggestion-modal': src_components_SuggestionModal,
    'nominee-item': src_components_NomineeItem
  },
  methods: {
    setSortType: function setSortType(sortType) {
      this.$store.dispatch('setSortType', {
        categoryId: this.category.id,
        sortType: sortType.type
      });
    },
    onFocusSearch: function onFocusSearch() {
      var grid = this.$refs.grid;


      if (SEARCH_FIXED && grid && grid.scrollIntoView) {
        grid.scrollIntoView();
      }
    },
    clearCategory: function clearCategory() {
      this.$store.dispatch('clearCategory', {
        categoryId: this.category.id
      });
    },
    stylesForNominee: function stylesForNominee(nominee) {
      return nominee.image ? {
        backgroundImage: 'url(' + nominee.image + ')'
      } : {};
    },
    classForStationTag: function classForStationTag(tag) {
      return {
        tag: true,
        'tag--active': this.isSelectedChannelTag(tag)
      };
    },
    classForDayPartTag: function classForDayPartTag(tag) {
      return {
        tag: true,
        'tag--daypart': true,
        'tag--active': this.isSelectedDayPartTag(tag)
      };
    },
    classForGridItem: function classForGridItem(filteredNominees) {
      return {
        grid__item: true,
        'grid__item--few': filteredNominees.length <= 10
      };
    },
    isSelectedChannelTag: function isSelectedChannelTag(tag) {
      return this.selectedChannelId === tag;
    },
    isSelectedDayPartTag: function isSelectedDayPartTag(tag) {
      return this.selectedDayPartId === tag;
    },
    toggleStationTag: function toggleStationTag(tag) {
      this.$store.dispatch('setSelectedChannelId', {
        tagId: tag,
        categoryId: this.category.id
      });
    },
    toggleDayPartTag: function toggleDayPartTag(tag) {
      this.$store.dispatch('setSelectedDayPartId', {
        tagId: tag,
        categoryId: this.category.id
      });
    },
    updateKeyword: function updateKeyword(e) {
      this.$store.dispatch('setKeyword', {
        keyword: e.target.value,
        categoryId: this.category.id
      });
    },
    urlForCategory: function urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categoryId: category.id
        }
      };
    },
    urlForNominee: function urlForNominee(nominee) {
      return {
        name: 'nominee',
        params: {
          categoryId: this.category.id,
          nomineeId: nominee.id,
          nomineeSlug: nominee.slug
        }
      };
    },
    classForNominee: function classForNominee(nominee) {
      return {
        item: true,
        'item--nominee': true,
        'item--disabled': this.activeNominee && !(this.activeNominee.id === nominee.id),
        'item--selected': this.isSelectedNominee(nominee),
        'item--hyphenate': nominee.name.split(' ').some(function (word) {
          return word.length > HYPHENATE_AT;
        })
      };
    },
    isSelectedNominee: function isSelectedNominee(nominee) {
      return this.selected.find(function (_ref) {
        var nomineeId = _ref.nomineeId;
        return nomineeId === nominee.id;
      });
    },
    hasSelectedNominee: function hasSelectedNominee(category) {
      return this.selected.find(function (_ref2) {
        var categoryId = _ref2.categoryId;
        return categoryId === category.id;
      });
    }
  },
  watch: {
    category: {
      handler: function handler() {
        util_triggerResize();
      },

      deep: true
    }
  },
  computed: {
    selectedChannelId: function selectedChannelId() {
      return this.category.selectedChannelId;
    },
    selectedDayPartId: function selectedDayPartId() {
      return this.category.selectedDayPartId;
    },
    keyword: function keyword() {
      return this.category.keyword;
    },
    sortType: function sortType() {
      return this.category.sortType;
    },
    selected: function selected() {
      return this.$store.state.selected;
    },
    loaded: function loaded() {
      return this.$store.state.loaded;
    },
    selectedNominee: function selectedNominee() {
      var _this = this;

      var selected = this.selected.find(function (_ref3) {
        var categoryId = _ref3.categoryId;
        return categoryId === _this.category.id;
      });

      return selected ? this.nominees.find(function (nominee) {
        return nominee.id === selected.nomineeId;
      }) : null;
    },
    selectedSuggestion: function selectedSuggestion() {
      var _this2 = this;

      var selected = this.selected.find(function (_ref4) {
        var categoryId = _ref4.categoryId;
        return categoryId === _this2.category.id;
      });

      if (!selected || typeof selected.suggestionName === 'undefined') {
        return null;
      }

      return selected;
    },
    categories: function categories() {
      return this.$store.state.categories;
    },
    otherCategories: function otherCategories() {
      var _this3 = this;

      return this.categories.filter(function (category) {
        return !_this3.selected.some(function (_ref5) {
          var categoryId = _ref5.categoryId;
          return categoryId === category.id;
        });
      });
    },
    category: function category() {
      var _this4 = this;

      return this.categories.find(function (_ref6) {
        var id = _ref6.id;
        return id === _this4.categoryId;
      });
    },
    nominees: function nominees() {
      return this.$store.getters.getNomineesByCategoryId(this.category.id);
    },
    activeNominee: function activeNominee() {
      var _this5 = this;

      return this.nomineeId ? this.filteredNominees.find(function (_ref7) {
        var id = _ref7.id;
        return id === _this5.nomineeId;
      }) : null;
    },
    filteredNominees: function filteredNominees() {
      return this.$store.getters.getFilteredNomineesByCategoryId(this.category.id).sort();
    },
    tags: function tags() {
      var normalized = {};

      this.nominees.forEach(function (nominee) {
        if (nominee.showtimes) {
          nominee.showtimes.forEach(function (tag) {
            normalized[tag.id] = tag;
          });
        }
      });

      return values_default()(normalized);
    },
    showtimesTags: function showtimesTags() {
      return this.$store.state.showtimesTags;
    },
    stationsTags: function stationsTags() {
      return this.$store.state.stationsTags[this.category.id].sort();
    },
    allowSuggestions: function allowSuggestions() {
      return this.$store.state.allowSuggestions;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c907a83c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Category.vue
var Category_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.category)?_c('div',[_c('p',{staticClass:"tabs"},_vm._l((_vm.categories),function(tab){return _c('router-link',{key:tab.id,staticClass:"tab",attrs:{"active-class":"tab--active","to":_vm.urlForCategory(tab)}},[_vm._v("\n      "+_vm._s(tab.name)+"\n      "),(_vm.hasSelectedNominee(tab))?_c('i',{staticClass:"fa fa-check"}):_vm._e()])}),1),_vm._v(" "),(_vm.selectedNominee || _vm.selectedSuggestion)?_c('div',[(_vm.selectedSuggestion)?[_c('div',{staticClass:"breadcrumb ml--lg"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Categorie")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.category.name))])],1),_vm._v(" "),_c('div',{staticClass:"p--md container--border"},[_c('h1',{staticClass:"p--md"},[_vm._v("Jouw suggestie")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('img',{staticClass:"img--box is-pulled-left",attrs:{"src":"static/rr_fallback.png"}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.selectedSuggestion.suggestionName))]),_vm._v(" "),(_vm.selectedSuggestion.suggestionStation)?_c('p',[_vm._v("\n            "+_vm._s(_vm.selectedSuggestion.suggestionStation)+"\n          ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"button button--small mt--md",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.clearCategory.apply(null, arguments)}}},[_vm._v("\n            Wijzigen\n          ")])]),_vm._v(" "),_c('div',{staticClass:"p--md"},[(_vm.otherCategories.length)?[_c('p',{staticClass:"paragraph"},[_c('strong',[_vm._v("Vergeet niet")]),_vm._v(" om ook een keuze te maken voor de categorie\n              "),_vm._l((_vm.otherCategories),function(otherCategory,index){return [(index > 0 && index < _vm.otherCategories.length)?_c('span',{key:otherCategory.name},[_vm._v("en/of")]):_vm._e(),_vm._v(" "),_c('router-link',{key:otherCategory.id,staticStyle:{"color":"#FBCA5F"},attrs:{"to":_vm.urlForCategory(otherCategory)}},[_vm._v("\n                  "+_vm._s(otherCategory.name)+"\n                ")])]})],2)]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"p--md",staticStyle:{"align-content":"end"}},[_c('router-link',{staticClass:"button button-confirm button--accent",attrs:{"to":{ name: 'submit' }}},[_vm._v("\n            Stemmen afronden\n            "),_c('i',{staticClass:"fa fa-long-arrow-right",attrs:{"aria-hidden":"true"}})])],1)])]:[_c('div',{staticClass:"breadcrumb ml--lg"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Categorie")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.category.name))])],1),_vm._v(" "),_c('div',{staticClass:"p--md container--border"},[_c('h1',{staticClass:"p--md title"},[_vm._v("Jouw keuze")]),_vm._v(" "),_c('div',{staticClass:"content"},[(_vm.selectedNominee.image)?_c('img',{staticClass:"img--box is-pulled-left",attrs:{"src":_vm.selectedNominee.image,"onerror":"this.src='static/rr_fallback.png';"}}):_c('img',{staticClass:"img--box is-pulled-left",attrs:{"src":"static/rr_fallback.png"}}),_vm._v(" "),_c('h2',{staticClass:"nameHeader"},[_vm._v(_vm._s(_vm.selectedNominee.name))]),_vm._v(" "),_vm._l((_vm.selectedNominee.stations),function(station){return _c('h3',{staticClass:"text-md"},[_vm._v(_vm._s(station))])}),_vm._v(" "),(_vm.selectedNominee.secondaryName)?_c('p',{staticClass:"description"},[_vm._v("\n            "+_vm._s(_vm.selectedNominee.secondaryName)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.selectedNominee.knownFor)?_c('p',[_vm._v(_vm._s(_vm.selectedNominee.knownFor))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"button button--small mt--md",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.clearCategory.apply(null, arguments)}}},[_vm._v("\n            Wijzigen\n          ")])],2),_vm._v(" "),_c('div',{staticClass:"p--md"},[(_vm.otherCategories.length)?[_c('p',{staticClass:"paragraph"},[_c('strong',[_vm._v("Vergeet niet")]),_vm._v(" om ook een keuze te maken voor de categorie\n\n              "),_vm._l((_vm.otherCategories),function(otherCategory,index){return [(index > 0 && index < _vm.otherCategories.length)?_c('span',{key:otherCategory.name},[_vm._v("en/of")]):_vm._e(),_vm._v(" "),_c('router-link',{key:otherCategory.id,staticStyle:{"color":"#FBCA5F"},attrs:{"to":_vm.urlForCategory(otherCategory)}},[_vm._v("\n                  "+_vm._s(otherCategory.name)+"\n                ")])]})],2)]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"p--md",staticStyle:{"align-content":"end"}},[_c('router-link',{staticClass:"button button-confirm button--accent",attrs:{"to":{ name: 'submit' }}},[_vm._v("\n            Stemmen afronden\n            "),_c('i',{staticClass:"fa fa-long-arrow-right",attrs:{"aria-hidden":"true"}})])],1)])]],2):_vm._e(),_vm._v(" "),(!_vm.selectedNominee && !_vm.selectedSuggestion)?_c('div',{staticClass:"search mx--lg",class:{ 'search--fixed': _vm.searchFixed }},[(_vm.category)?_c('div',[_c('div',{staticClass:"button-group is-pulled-right"},_vm._l((_vm.sortTypes),function(sortable){return _c('button',{key:sortable.type,staticClass:"button-icon",class:{ 'button-icon--active': _vm.sortType === sortable.type },attrs:{"title":sortable.title,"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.setSortType(sortable)}}},[_c('i',{staticClass:"fa fa-fw",class:sortable.icon,attrs:{"aria-hidden":"true"}})])}),0),_vm._v(" "),_c('div',{staticClass:"breadcrumb"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Categorie")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.category.name))])],1),_vm._v(" "),_c('div',{ref:"searchBar",staticClass:"search-bar",staticStyle:{"width":"auto"}},[_c('div',{staticClass:"form__field form__field--icon form__field--search"},[_c('input',{ref:"searchInput",staticClass:"form__input",attrs:{"type":"text","placeholder":"Zoek","aria-label":"Zoekterm"},domProps:{"value":_vm.category.keyword},on:{"input":_vm.updateKeyword,"focus":_vm.onFocusSearch}}),_vm._v(" "),_c('i',{staticClass:"fa fa-search",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.allowSuggestions && _vm.category.name === 'Podcast' )?_c('a',{staticClass:"button mt--md",on:{"click":function($event){$event.preventDefault();_vm.showSuggestionModal = true}}},[_vm._v("\n            Of voeg een suggestie toe\n          ")]):_vm._e()])]),_vm._v(" "),(_vm.category.name !== 'Podcast')?_c('button',{staticClass:"filterButton",on:{"click":function($event){_vm.showFilters = !_vm.showFilters}}},[_vm._v("\n        Filters\n      ")]):_vm._e(),_vm._v(" "),(_vm.showFilters === true && _vm.category.name !== 'Podcast')?_c('div',{attrs:{"id":"filters"}},[_c('div',{staticClass:"filter"},[_c('p',{staticClass:"tag-list"},_vm._l((_vm.showtimesTags),function(showtime,key){return _c('span',{key:key,class:_vm.classForDayPartTag(key),on:{"click":function($event){return _vm.toggleDayPartTag(key)}}},[(!_vm.isIOSSmall)?_c('i',{staticClass:"fa fa-clock-o",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v("\n              "+_vm._s(showtime)+"\n            ")])}),0)]),_vm._v(" "),(_vm.stationsTags.length > 0)?_c('div',{staticClass:"filter mb--md"},[_c('p',{staticClass:"tag-list"},_vm._l((_vm.stationsTags),function(station,key){return _c('span',{key:key,class:_vm.classForStationTag(station),on:{"click":function($event){return _vm.toggleStationTag(station)}}},[_vm._v("\n              "+_vm._s(station)+"\n            ")])}),0)]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nominee--container"},[(_vm.filteredNominees.length)?_c('div',{key:_vm.category.id,ref:"grid",staticClass:"grid grid--center"},_vm._l((_vm.filteredNominees),function(nominee){return _c('div',{key:nominee.id,class:_vm.classForGridItem(_vm.filteredNominees)},[_c('nominee-item',{key:nominee.id,class:_vm.classForNominee(nominee),attrs:{"nominee":nominee,"category":_vm.category}})],1)}),0):_c('p',{staticClass:"p--md"},[_vm._v("\n        Er zijn geen genomineerden gevonden binnen de opgegeven criteria.\n      ")])])]):_vm._e(),_vm._v(" "),(_vm.activeNominee)?_c('nominee-modal',{attrs:{"filteredNominees":_vm.filteredNominees,"nomineeId":_vm.activeNominee.id,"categoryId":_vm.category.id}}):_vm._e(),_vm._v(" "),(_vm.showSuggestionModal)?_c('suggestion-modal',{attrs:{"categoryId":_vm.category.id},on:{"closeModal":function($event){_vm.showSuggestionModal = false}}}):_vm._e()],1):_c('p',{staticClass:"p--md"},[_vm._v("\n  Deze pagina bestaat niet (meer).\n  "),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Klik hier om terug te keren naar de homepage")]),_vm._v(".\n")],1)}
var Category_staticRenderFns = []
var Category_esExports = { render: Category_render, staticRenderFns: Category_staticRenderFns }
/* harmony default export */ var components_Category = (Category_esExports);
// CONCATENATED MODULE: ./src/components/Category.vue
var Category_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Category___vue_template_functional__ = false
/* styles */
var Category___vue_styles__ = null
/* scopeId */
var Category___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Category___vue_module_identifier__ = null
var Category_Component = Category_normalizeComponent(
  Category,
  components_Category,
  Category___vue_template_functional__,
  Category___vue_styles__,
  Category___vue_scopeId__,
  Category___vue_module_identifier__
)

/* harmony default export */ var src_components_Category = (Category_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("+6Bu");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-invisible-recaptcha/src/InvisibleRecaptcha.vue
//
//
//
//
//
//
//

/* harmony default export */ var InvisibleRecaptcha = ({
	props: {
		sitekey: {
			type: String,
			required: true
		},

		badge: {
			type: String,
			required: false,
			default: 'bottomright'
		},

		theme: {
			type: String,
			required: false,
			default: 'dark'
		},

		validate: {
			type: Function,
			required: false
		},

		callback: {
			type: Function,
			required: true
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false
		},

		id: {
			type: String,
			required: false
		},

		reference: {
			type: String,
			required: false
		},

		type: {
			type: String,
			required: false,
			default: 'submit'
		}
	},

	data: function data() {
		return {
			widgetId: false,
			loaded: false
		};
	},

	methods: {
		render: function render() {
			var _this = this;

			this.widgetId = grecaptcha.render(this.recaptchaId, {
				sitekey: this.sitekey,
				size: 'invisible',
				badge: this.badge,
				theme: this.theme,
				callback: function callback(token) {
					_this.callback(token);
					grecaptcha.reset(_this.widgetId);
				}
			});
			this.loaded = true;
		},

		renderWait: function renderWait() {
			var self = this;
			setTimeout(function () {
				if (typeof grecaptcha !== 'undefined' && grecaptcha.render) self.render();else self.renderWait();
			}, 200);
		},

		click: function click() {
			if (!this.validate || this.validate && this.validate() !== false) grecaptcha.execute();
		}
	},

	computed: {
		computedClass: function computedClass() {
			var classArray = this.class ? this.class.split(' ') : [];

			if (this.value) {
				classArray.push('invisible-recaptcha');
			}

			return classArray;
		},
		recaptchaId: function recaptchaId() {
			return 'vue-invisible-recaptcha-' + this._uid;
		}
	},

	mounted: function mounted() {
		if (typeof grecaptcha === 'undefined') {
			var script = document.createElement('script');
			script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
			script.onload = this.renderWait;

			document.head.appendChild(script);
		} else this.render();
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ac06296","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-invisible-recaptcha/src/InvisibleRecaptcha.vue
var InvisibleRecaptcha_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:_vm.reference,class:_vm.computedClass,attrs:{"id":_vm.id,"type":_vm.type,"disabled":!_vm.loaded || _vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('div',{attrs:{"id":_vm.recaptchaId,"data-size":"invisible"}}),_vm._v(" "),_vm._t("default")],2)}
var InvisibleRecaptcha_staticRenderFns = []
var InvisibleRecaptcha_esExports = { render: InvisibleRecaptcha_render, staticRenderFns: InvisibleRecaptcha_staticRenderFns }
/* harmony default export */ var src_InvisibleRecaptcha = (InvisibleRecaptcha_esExports);
// CONCATENATED MODULE: ./node_modules/vue-invisible-recaptcha/src/InvisibleRecaptcha.vue
var InvisibleRecaptcha_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var InvisibleRecaptcha___vue_template_functional__ = false
/* styles */
var InvisibleRecaptcha___vue_styles__ = null
/* scopeId */
var InvisibleRecaptcha___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var InvisibleRecaptcha___vue_module_identifier__ = null
var InvisibleRecaptcha_Component = InvisibleRecaptcha_normalizeComponent(
  InvisibleRecaptcha,
  src_InvisibleRecaptcha,
  InvisibleRecaptcha___vue_template_functional__,
  InvisibleRecaptcha___vue_styles__,
  InvisibleRecaptcha___vue_scopeId__,
  InvisibleRecaptcha___vue_module_identifier__
)

/* harmony default export */ var vue_invisible_recaptcha_src_InvisibleRecaptcha = (InvisibleRecaptcha_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Checkbox.vue
//
//
//
//
//
//
//

/* harmony default export */ var Checkbox = ({
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    checkUncheck: function checkUncheck(event) {
      this.$emit('input', event.target.checked);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca480f76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checkbox.vue
var Checkbox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.checkUncheck}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])}
var Checkbox_staticRenderFns = []
var Checkbox_esExports = { render: Checkbox_render, staticRenderFns: Checkbox_staticRenderFns }
/* harmony default export */ var components_Checkbox = (Checkbox_esExports);
// CONCATENATED MODULE: ./src/components/Checkbox.vue
var Checkbox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Checkbox___vue_template_functional__ = false
/* styles */
var Checkbox___vue_styles__ = null
/* scopeId */
var Checkbox___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Checkbox___vue_module_identifier__ = null
var Checkbox_Component = Checkbox_normalizeComponent(
  Checkbox,
  components_Checkbox,
  Checkbox___vue_template_functional__,
  Checkbox___vue_styles__,
  Checkbox___vue_scopeId__,
  Checkbox___vue_module_identifier__
)

/* harmony default export */ var src_components_Checkbox = (Checkbox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Submit.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var captchaSiteKey = "6LegDn4UAAAAABDiXFEZIIWVp6-zmbigNVXeUVxC";

/* harmony default export */ var Submit = ({
  name: 'Submit',

  components: {
    'invisible-recaptcha': vue_invisible_recaptcha_src_InvisibleRecaptcha,
    'checkbox': src_components_Checkbox
  },

  data: function data() {
    return {
      email: '',
      agreed: false,
      keepUpToDate: false,
      sending: false,
      voteSent: false,
      hasVotingError: false,
      hasInvalidEmail: false,
      didNotAgree: false,
      captchaSiteKey: captchaSiteKey
    };
  },


  computed: {
    round: function round() {
      return this.$store.state.rounds;
    },
    offlineDescription: function offlineDescription() {
      return this.$store.state.frontend.offline_description ? this.$store.state.frontend.offline_description : 'Er kan momenteel niet gestemd worden.';
    },
    hasRound: function hasRound() {
      return typeof_default()(this.round) === 'object';
    },
    selectedNominees: function selectedNominees() {
      return this.$store.state.selected.filter(function (selected) {
        return typeof selected.nomineeId !== 'undefined';
      });
    },
    selectedSuggestions: function selectedSuggestions() {
      var selected = this.$store.state.selected.filter(function (selected) {
        return typeof selected.suggestionName !== 'undefined';
      });

      return selected.map(function (_ref) {
        var suggestionName = _ref.suggestionName,
            suggestionStation = _ref.suggestionStation,
            categoryId = _ref.categoryId,
            obj = objectWithoutProperties_default()(_ref, ['suggestionName', 'suggestionStation', 'categoryId']);

        return {
          name: suggestionName,
          secondary_name: suggestionStation || '-',
          categoryId: categoryId
        };
      });
    },
    selection: function selection() {
      return this.$store.getters.selection;
    },
    anySelected: function anySelected() {
      return this.selection.some(function (_ref2) {
        var nominee = _ref2.nominee,
            suggestion = _ref2.suggestion;
        return nominee || suggestion;
      });
    }
  },

  methods: {
    isValidEmail: function isValidEmail() {
      return this.$refs.emailInput.validity.valid;
    },
    isIncomplete: function isIncomplete() {
      return this.agreed === false || this.isValidEmail() === false;
    },
    validate: function validate() {
      return this.isIncomplete() === false;
    },
    submit: function submit(captchaHash) {
      var _this = this;

      if (this.isIncomplete()) {
        this.hasInvalidEmail = this.isValidEmail() === false;
        this.didNotAgree = this.agreed === false;

        return;
      }

      var round = this.round;

      var data = extends_default()({
        captchaHash: captchaHash,
        roundId: round.id
      }, this.selectedNominees.length > 0 ? { votes: this.selectedNominees } : {}, this.$store.state.allowSuggestions ? { suggestions: this.selectedSuggestions } : {}, {
        email: this.email,
        extraFields: {
          keepUpToDate: this.keepUpToDate
        }
      });

      this.sending = true;

      request_post('voting/vote', {
        data: stringify_default()(data)
      }).then(function (response) {
        if (response.ok) {
          response.json().then(function (_ref3) {
            var data = _ref3.data;

            if (data.saved) {
              _this.voteSent = true;
              _this.$store.dispatch('clearSelected');
            } else {
              _this.hasVotingError = true;
            }
          });
        } else {
          _this.hasVotingError = true;
        }

        _this.sending = false;
      }).catch(function () {
        _this.hasVotingError = true;
        _this.sending = false;
      });
    },
    stylesForNominee: function stylesForNominee(nominee) {
      if (nominee.image) {
        return {
          backgroundImage: 'url(' + nominee.image + ')'
        };
      } else if (!nominee.image) {
        return {
          backgroundImage: 'url(/static/rr_fallback.png)'
        };
      }
    },
    urlForCategory: function urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categoryId: category.id
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ea1a8fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Submit.vue
var Submit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasRound)?_c('div',[_c('div',[(_vm.voteSent)?_c('div',{staticClass:"p--lg container--border"},[_c('h1',{staticClass:"pb--md"},[_vm._v("Bijna klaar...")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]):[_c('div',{staticClass:"breadcrumb ml--lg",staticStyle:{"margin-top":"48px"}},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Categorie")]),_vm._v(" "),_c('span',[_vm._v("Inzenden")])],1),_vm._v(" "),_c('div',{staticClass:"p--md container--border"},[_c('h1',{staticClass:"p--md title"},[_vm._v("Inzenden")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._l((_vm.selection),function(choice){return [_c('div',{key:choice.category.name,staticClass:"col col--1-3"},[_c('h3',{staticClass:"badge badge--gold"},[_vm._v("\n                "+_vm._s(choice.category.name)+"\n              ")]),_vm._v(" "),(choice.nominee)?_c('router-link',{staticClass:"item item--nominee",attrs:{"to":_vm.urlForCategory(choice.category)}},[_c('div',{staticClass:"item__body item__body--loaded",style:(_vm.stylesForNominee(choice.nominee))}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(choice.nominee.name))])]):(choice.suggestion)?_c('router-link',{staticClass:"item item--nominee",attrs:{"to":_vm.urlForCategory(choice.category)}},[_c('div',{staticClass:"item__body item__body--loaded item__body--no-image"}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(choice.suggestion.suggestionName))])]):_c('router-link',{staticClass:"item item--empty",attrs:{"to":_vm.urlForCategory(choice.category)}},[_c('span',[_vm._v("Kies")])])],1)]})],2),_vm._v(" "),(_vm.anySelected)?_c('form',{staticClass:"form p--md",staticStyle:{"margin-top":"2rem"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"checkbox--container"},[_c('checkbox',{attrs:{"disabled":_vm.sending},model:{value:(_vm.agreed),callback:function ($$v) {_vm.agreed=$$v},expression:"agreed"}}),_vm._v(" "),_vm._m(2)],1),_vm._v(" "),(_vm.didNotAgree)?_c('p',{staticClass:"text--error"},[_vm._v("\n              U moet nog akkoord gaan met voorwaarden\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"checkbox--container"},[_c('checkbox',{attrs:{"disabled":_vm.sending},model:{value:(_vm.keepUpToDate),callback:function ($$v) {_vm.keepUpToDate=$$v},expression:"keepUpToDate"}}),_vm._v(" "),_c('label',{staticClass:"form__label",attrs:{"for":"form__field_update"}},[_vm._v("\n                Ja, ik wil graag op de hoogte worden gehouden van de RadioRing en andere AVROTROS-programma's\n              ")])],1)]),_vm._v(" "),_c('div',{staticClass:"form__field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"emailInput",staticClass:"form__input mt--md mail__input",attrs:{"type":"email","required":"","placeholder":"E-mailadres *","disabled":_vm.sending,"id":"form__field_email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),(_vm.hasInvalidEmail)?_c('p',{staticClass:"text--error"},[_vm._v("\n              Vul een geldig e-mailadres in\n            ")]):_vm._e()]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"form__field",staticStyle:{"display":"grid","justify-content":"end","margin-top":"1rem"}},[_c('invisible-recaptcha',{staticClass:"button",attrs:{"sitekey":_vm.captchaSiteKey,"validate":_vm.validate,"callback":_vm.submit,"type":"submit","disabled":_vm.sending || _vm.isIncomplete()}},[_vm._v("\n              Inzenden\n            ")])],1)]):_c('p',{staticClass:"p--md"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Selecteer")]),_vm._v("\n          eerst een of meer genomineerden.\n        ")],1)])]],2)]):_c('p',{staticClass:"p--md",domProps:{"innerHTML":_vm._s(_vm.offlineDescription)}})}
var Submit_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"pb--lg"},[_c('strong',{staticClass:"text--accent"},[_vm._v("Check je mailbox")]),_vm._v(" voor een bevestigingsmail en klik daarin op\n        de link om jouw stem definitief te maken. Doe je dat niet, dan kunnen we jouw stem helaas niet\n        meetellen.\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"pb--lg"},[_c('strong',[_vm._v("Geen mail ontvangen? Kijk dan even in je spam folder.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__label",attrs:{"for":"form__field_conditions"}},[_vm._v("\n                Ik ga akkoord met de\n                "),_c('a',{attrs:{"target":"_blank","href":"https://www.avrotros.nl/article/reglementen-radio-ring-stemsite-2025~1357/"}},[_vm._v("\n                  voorwaarden\n                ")]),_vm._v("\n                *\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"font-size":"x-small"}},[_c('i',[_vm._v("\n              Velden met een * zijn verplicht. Het is mogelijk om vaker te stemmen per e-mailadres, maar de\n              reeds uitgebrachte stem wordt dan automatisch overschreven door de nieuwe stem.\n            ")])])}]
var Submit_esExports = { render: Submit_render, staticRenderFns: Submit_staticRenderFns }
/* harmony default export */ var components_Submit = (Submit_esExports);
// CONCATENATED MODULE: ./src/components/Submit.vue
var Submit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Submit___vue_template_functional__ = false
/* styles */
var Submit___vue_styles__ = null
/* scopeId */
var Submit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Submit___vue_module_identifier__ = null
var Submit_Component = Submit_normalizeComponent(
  Submit,
  components_Submit,
  Submit___vue_template_functional__,
  Submit___vue_styles__,
  Submit___vue_scopeId__,
  Submit___vue_module_identifier__
)

/* harmony default export */ var src_components_Submit = (Submit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Confirm.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var FRONTEND_DOMAIN = "https://radioring.avrotros.nl";


/* harmony default export */ var Confirm = ({
  name: 'Confirm',
  data: function data() {
    return {
      loading: true,
      confirmed: false,
      replay: false,
      notFound: false,
      nomineeIds: [],
      suggestions: [],
      shareUrl: encodeURIComponent(FRONTEND_DOMAIN)
    };
  },

  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  methods: {
    findCategoryName: function findCategoryName(categoryId) {
      var category = this.categories.find(function (category) {
        return category.id === Number(categoryId);
      });
      return category.name;
    },
    whatsApp: function whatsApp() {
      var target = '_blank';
      var features = 'noopener,noreferrer';
      var platform = this.isMobile ? 'api' : 'web';
      var base = 'https://' + platform + '.whatsapp.com/send';

      window.open(base + '?text=' + (this.shareText.replace(/\s+/, ' ') + ' ' + decodeURIComponent(this.shareUrl)), target, features);
    }
  },
  computed: {
    loaded: function loaded() {
      return this.$store.state.loaded;
    },
    round: function round() {
      return this.$store.state.rounds;
    },
    hasRound: function hasRound() {
      return typeof_default()(this.round) === 'object';
    },
    nominees: function nominees() {
      var _this = this;

      return this.$store.state.nominees.filter(function (_ref) {
        var id = _ref.id;
        return _this.nomineeIds.includes(id);
      });
    },
    categories: function categories() {
      return this.$store.state.categories;
    },
    shareText: function shareText() {
      var nominees = this.nominees.map(function (_ref2) {
        var name = _ref2.name,
            hashtag = _ref2.hashtag;
        return name + (hashtag && hashtag.length ? ' (' + hashtag + ')' : '');
      });

      var suggestions = this.suggestions.map(function (_ref3) {
        var name = _ref3.name,
            nameSecondary = _ref3.nameSecondary;
        return name + (nameSecondary && nameSecondary.length && nameSecondary !== '-' ? ' (' + nameSecondary + ')' : '');
      });

      var sentence = [].concat(toConsumableArray_default()(nominees), toConsumableArray_default()(suggestions)).reduce(function (acc, curr, index, names) {
        if (index === 0) {
          return curr;
        }

        return index < names.length - 1 ? acc + ', ' + curr : acc + ' en ' + curr;
      }, '');

      return encodeURIComponent('Ik heb gestemd op ' + sentence + '. Stem nu ook op jouw favoriete programma voor de RadioRing 2025!');
    },
    isMobile: function isMobile() {
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      );
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    get('voting/vote/confirm/' + this.uuid).then(function (response) {
      if (response.ok) {
        response.json().then(function (_ref4) {
          var data = _ref4.data;
          var confirmed = data.confirmed,
              replay = data.replay,
              notFound = data.notFound,
              nominees = data.nominees,
              suggestions = data.suggestions;

          _this2.confirmed = confirmed;
          _this2.replay = replay;
          _this2.notFound = notFound;
          _this2.suggestions = suggestions;
          _this2.nomineeIds = nominees.map(Number);
          _this2.loading = false;
        });
      } else {
        _this2.notFound = true;
        _this2.loading = false;
      }
    }).catch(function () {
      _this2.notFound = true;
      _this2.loading = false;
    });
    get('voting/votes/' + this.uuid).then(function (response) {
      return response.json();
    }).then(function (_ref5) {
      var data = _ref5.data;
      var votes = data.votes;

      _this2.votedNominees = votes;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70fd9226","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confirm.vue
var Confirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasRound)?_c('div',[(_vm.loading)?_c('p',[_vm._v("\n    een moment geduld alstublieft...\n  ")]):(_vm.confirmed)?[_c('div',{staticClass:"p--md"},[_c('div',{staticClass:"is-centered"},[(!_vm.replay)?_c('h1',{staticClass:"title"},[_vm._v("Je stem is bevestigd!")]):_vm._e(),_vm._v(" "),(_vm.replay)?_c('h1',[_vm._v("Je stem is bevestigd")]):_vm._e(),_vm._v(" "),(_vm.nominees.length || _vm.suggestions.length)?_c('p',{staticClass:"votes",staticStyle:{"margin-bottom":"1rem"}},[_vm._l((_vm.nominees),function(nominee){return [_c('div',{staticClass:"confirmed-nominees"},[_c('b',{staticClass:"categoryTitle"},[_vm._v(_vm._s(_vm.findCategoryName(nominee.categoryId)))]),_vm._v(" "),(nominee.image)?_c('img',{key:nominee.id,staticClass:"vote",staticStyle:{"background":"linear-gradient(180deg ,#121212, transparent)"},attrs:{"src":nominee.image,"onerror":"this.src='static/rr_fallback.png';"}}):_c('img',{staticClass:"vote",attrs:{"src":"static/rr_fallback.png"}}),_vm._v(" "),_c('h3',{staticClass:"selectionHeader"},[_vm._v(_vm._s(nominee.name))]),_vm._v(" "),_c('h3',{staticClass:"text-sm"},[_vm._v(" "+_vm._s(nominee.broadcaster))]),_vm._v(" "),_vm._l((nominee.stations),function(stations){return _c('h3',{staticClass:"text-sm"},[_vm._v(" "+_vm._s(stations))])}),_vm._v(" "),(nominee.name !== nominee.secondaryName)?_c('span',{staticClass:"selectionText"},[_vm._v(_vm._s(nominee.secondaryName))]):_vm._e()],2)]}),_vm._v(" "),_vm._l((_vm.suggestions),function(suggestion){return [_c('div',{staticClass:"confirmed-nominees"},[_c('img',{staticClass:"vote",attrs:{"src":"static/rr_fallback.png"}}),_vm._v(" "),_c('span',{staticStyle:{"width":"160px","word-break":"break-word","font-size":"14px","font-weight":"bold"}},[_vm._v("\n                "+_vm._s(suggestion.name)+"\n              ")])])]})],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"pb--lg"},[_vm._v("\n          Bedankt voor het stemmen op de RadioRing!\n        ")]),_vm._v(" "),_c('p',{staticClass:"pb--lg"},[_vm._v("\n          Vergeet niet om je stem te delen met je vrienden via Facebook, X en WhatsApp!\n        ")])]),_vm._v(" "),_c('div',{staticClass:"share-buttons"},[_c('a',{staticClass:"share__button facebook",attrs:{"href":("https://facebook.com/sharer/sharer.php?u=" + _vm.shareUrl),"rel":"noopener","target":"_blank","title":"Delen op Facebook"}},[_c('svg',{attrs:{"viewBox":"0 0 320 512","aria-hidden":"true","height":"20"}},[_c('path',{attrs:{"fill":"currentColor","d":"M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"}})])]),_vm._v(" "),_c('a',{staticClass:"share__button x",attrs:{"href":("https://twitter.com/intent/tweet/?text=" + _vm.shareText + "&url=" + _vm.shareUrl + "&hashtags=radioring2025"),"rel":"noopener","target":"_blank","title":"Delen op X"}},[_c('svg',{attrs:{"height":"20","viewBox":"0 0 1200 1227","xmlns":"http://www.w3.org/2000/svg","fill":"#000"}},[_c('path',{attrs:{"d":"M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"}})])]),_vm._v(" "),_c('button',{staticClass:"share__button whatsapp",attrs:{"type":"submit","title":"Delen op WhatsApp"},on:{"click":_vm.whatsApp}},[_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19.355 4.552a10.328 10.328 0 0 0-7.36-3.052C6.258 1.5 1.59 6.169 1.59 11.906c0 1.833.478 3.624 1.388 5.203L1.5 22.5l5.517-1.448c1.519.83 3.23 1.265 4.974 1.265h.004c5.733 0 10.505-4.669 10.505-10.406 0-2.78-1.181-5.39-3.145-7.36zm-7.36 16.012A8.634 8.634 0 0 1 7.59 19.36l-.314-.187-3.272.858.872-3.192-.206-.329a8.62 8.62 0 0 1-1.322-4.603c0-4.767 3.881-8.648 8.653-8.648 2.31 0 4.481.9 6.112 2.536 1.632 1.636 2.635 3.806 2.63 6.117 0 4.772-3.98 8.653-8.747 8.653zm4.744-6.478c-.258-.131-1.537-.76-1.777-.844-.239-.089-.412-.131-.585.131-.174.263-.67.844-.825 1.022-.15.174-.305.197-.563.066-1.528-.764-2.531-1.364-3.539-3.094-.267-.46.267-.426.764-1.42.084-.174.042-.324-.023-.455-.066-.131-.586-1.41-.802-1.931-.21-.506-.427-.436-.586-.445-.15-.01-.323-.01-.497-.01a.963.963 0 0 0-.694.324c-.239.262-.909.89-.909 2.17 0 1.28.933 2.517 1.06 2.69.13.174 1.832 2.8 4.443 3.929 1.65.712 2.297.773 3.122.651.502-.075 1.538-.628 1.753-1.237.216-.61.216-1.13.15-1.238-.06-.117-.234-.182-.492-.31z","fill":"#FFF","fill-rule":"nonzero"}})])])])])]:(_vm.notFound)?_c('p',{staticClass:"p--lg text--container"},[_vm._v("\n    Deze bevestiging is ongeldig.\n  ")]):_vm._e()],2):_c('p',{staticClass:"p--lg text--container"},[_vm._v("\n  Er kan op dit moment niet (meer) gestemd worden.\n")])}
var Confirm_staticRenderFns = []
var Confirm_esExports = { render: Confirm_render, staticRenderFns: Confirm_staticRenderFns }
/* harmony default export */ var components_Confirm = (Confirm_esExports);
// CONCATENATED MODULE: ./src/components/Confirm.vue
var Confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Confirm___vue_template_functional__ = false
/* styles */
var Confirm___vue_styles__ = null
/* scopeId */
var Confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Confirm___vue_module_identifier__ = null
var Confirm_Component = Confirm_normalizeComponent(
  Confirm,
  components_Confirm,
  Confirm___vue_template_functional__,
  Confirm___vue_styles__,
  Confirm___vue_scopeId__,
  Confirm___vue_module_identifier__
)

/* harmony default export */ var src_components_Confirm = (Confirm_Component.exports);

// CONCATENATED MODULE: ./src/router/comscore.js

var comscore_comscore = function comscore(_ref) {
  var path = _ref.path;

  if (!window.udm_) {
    return;
  }

  path = path === '/' ? 'splash' : path.replace(/^\//, '').replace(/\//g, '.');

  var params = {
    c1: 2,
    c2: 17827132,
    ns_site: 'po-totaal',
    name: 'avrotrosportal.pip.programmas-sites.gouden-radioring.' + path,
    potag1: 'avrotrosportal',
    potag2: 'goudenradioring',
    potag3: 'avrotros',
    potag4: 'avrotros',
    potag5: 'omroepportal',
    potag6: 'geen',
    potag7: 'geen',
    potag8: 'site',
    potag9: 'site'
  };

  var protocol = 'http' + (document.location.href.charAt(4) === 's' ? 's://sb' : '://b');
  var query = keys_default()(params).map(function (key) {
    return key + '=' + params[key];
  }).join('&');

  window.udm_(protocol + '.scorecardresearch.com/p?' + query);
};

/* harmony default export */ var router_comscore = (comscore_comscore);
// CONCATENATED MODULE: ./src/router/atInternet.js
var atInternet = function atInternet() {};

if (window.ATInternet) {
  var atTag = new window.ATInternet.Tracker.Tag();
  var AT_INTERNET_SITE_ID = 595271;

  atInternet = function atInternet(_ref) {
    var path = _ref.path,
        name = _ref.name;

    var pageData = {
      name: path,
      level1: AT_INTERNET_SITE_ID,
      level2: 27,
      chapter1: 'live',
      page: path,
      platform: 'site',
      broadcaster: 'avrotros',
      program: 'gouden radioring',
      level2type: 'portal',
      eventtype: 'index',
      mediatype: 'general',
      nb_idfa: 'no_value',
      thema: 'muziek'
    };

    atTag.page.set(pageData);
    atTag.dispatch();
  };
}

/* harmony default export */ var router_atInternet = (atInternet);
// CONCATENATED MODULE: ./src/router/pixel.js
var pixel = function pixel() {
  if (!window.fbq) {
    return;
  }

  window.fbq('track', 'PageView');
};

/* harmony default export */ var router_pixel = (pixel);
// CONCATENATED MODULE: ./src/router/index.js












vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'splash',
    component: src_components_Splash
  }, {
    path: '/home',
    name: 'home',
    component: src_components_Home
  }, {
    path: '/categorie/:categoryId([0-9])',
    name: 'category',
    component: src_components_Category,
    props: function props(route) {
      return {
        categoryId: parseInt(route.params.categoryId),
        nomineeId: null
      };
    }
  }, {
    path: '/categorie/:categoryId([0-9])/:nomineeId(\\d+)/:nomineeSlug([a-z0-9-]+)',
    name: 'nominee',
    component: src_components_Category,
    props: function props(route) {
      return {
        categoryId: parseInt(route.params.categoryId),
        nomineeId: parseInt(route.params.nomineeId, 10)
      };
    }
  }, {
    path: '/inzenden',
    name: 'submit',
    component: src_components_Submit
  }, {
    path: '/bevestigen/:uuid([a-z0-9-]{36})',
    name: 'confirm',
    component: src_components_Confirm,
    props: function props(route) {
      return {
        uuid: route.params.uuid
      };
    }
  }, {
    path: '*',
    redirect: '/'
  }]
});

var npotag = {
  lib: null,
  tag: null,
  page: null,
  queue: [] | null,

  load: function load() {
    var script = document.createElement('script');
    script.src = 'https://npotag.npo-data.nl/prod/npo-tag.min.js';
    script.async = true;
    script.onload = npotag.onLoaded;
    document.head.appendChild(script);
  },
  onLoaded: function onLoaded() {
    npotag.lib = window.npotag;
    npotag.tag = npotag.lib.newTag({
      brand: 'avotros',
      brand_id: 630226,
      platform: 'site',
      environment:  true ? 'prod' : 'dev'
    }, [npotag.lib.newGovoltePlugin()]);

    var queue = npotag.queue;
    if (queue) {
      npotag.queue = null;
      queue.forEach(function (method, args) {
        npotag[method].apply(npotag, toConsumableArray_default()(args));
      });
    }
  },
  trackPage: function trackPage(page) {
    if (npotag.queue) {
      npotag.queue.push({ method: 'trackPage', args: [page] });
      return;
    }

    npotag.page = npotag.lib.newPageTracker(npotag.tag, {
      page: page,
      page_chapter1: 'programmas',
      page_chapter2: 'radioring',
      page_chapter3: 'stemtool',
      platform: 'site',
      broadcaster: 'avrotros',
      program: 'radioring',
      content_context_id: 'POMS_S_AT_5941185'
    });
    npotag.page.pageView();
  }
};
npotag.load();

router.afterEach(function (to) {
  if (!window.canTrackAnalytics()) {
    return;
  }

  try {
    router_atInternet(to);
    router_comscore(to);
    router_pixel(to);
    npotag.trackPage(to.fullPath);
  } catch (e) {
    console.warn(e);
  }
});

/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ./src/store/actions.js
/* harmony default export */ var actions = ({
  setLoaded: function setLoaded(_ref, loaded) {
    var commit = _ref.commit;

    commit('setLoaded', loaded);
  },
  setAllowSuggestions: function setAllowSuggestions(_ref2, allowSuggestions) {
    var commit = _ref2.commit;

    commit('setAllowSuggestions', allowSuggestions);
  },
  setOffline: function setOffline(_ref3, offline) {
    var commit = _ref3.commit;

    commit('setOffline', offline);
  },
  setNominees: function setNominees(_ref4, nominees) {
    var commit = _ref4.commit;

    commit('setNominees', nominees);
  },
  setCategories: function setCategories(_ref5, categories) {
    var commit = _ref5.commit;

    commit('setCategories', categories);
  },
  setFrontend: function setFrontend(_ref6, frontend) {
    var commit = _ref6.commit;

    commit('setFrontend', frontend);
  },
  setRounds: function setRounds(_ref7, rounds) {
    var commit = _ref7.commit;

    commit('setRounds', rounds);
  },
  setShowtimesTags: function setShowtimesTags(_ref8, showtimeTags) {
    var commit = _ref8.commit;

    commit('setShowtimesTags', showtimeTags);
  },
  setStationsTags: function setStationsTags(_ref9, stationsTags) {
    var commit = _ref9.commit;

    commit('setStationsTags', stationsTags);
  },
  selectNominee: function selectNominee(_ref10, _ref11) {
    var commit = _ref10.commit;
    var categoryId = _ref11.categoryId,
        nomineeId = _ref11.nomineeId;

    commit('selectNominee', { categoryId: categoryId, nomineeId: nomineeId });
  },
  addSuggestion: function addSuggestion(_ref12, _ref13) {
    var commit = _ref12.commit;
    var categoryId = _ref13.categoryId,
        suggestionName = _ref13.suggestionName,
        suggestionStation = _ref13.suggestionStation;

    commit('addSuggestion', { categoryId: categoryId, suggestionName: suggestionName, suggestionStation: suggestionStation });
  },
  clearSelected: function clearSelected(_ref14) {
    var commit = _ref14.commit;

    commit('clearSelected');
  },
  clearCategory: function clearCategory(_ref15, _ref16) {
    var commit = _ref15.commit;
    var categoryId = _ref16.categoryId;

    commit('clearCategory', { categoryId: categoryId });
  },
  setSelectedChannelId: function setSelectedChannelId(_ref17, _ref18) {
    var commit = _ref17.commit;
    var categoryId = _ref18.categoryId,
        tagId = _ref18.tagId;

    commit('setSelectedChannelId', { categoryId: categoryId, tagId: tagId });
  },
  setSelectedDayPartId: function setSelectedDayPartId(_ref19, _ref20) {
    var commit = _ref19.commit;
    var categoryId = _ref20.categoryId,
        tagId = _ref20.tagId;

    commit('setSelectedDayPartId', { categoryId: categoryId, tagId: tagId });
  },
  setKeyword: function setKeyword(_ref21, _ref22) {
    var commit = _ref21.commit;
    var categoryId = _ref22.categoryId,
        keyword = _ref22.keyword;

    commit('setKeyword', { categoryId: categoryId, keyword: keyword });
  },
  setSortType: function setSortType(_ref23, _ref24) {
    var commit = _ref23.commit;
    var categoryId = _ref24.categoryId,
        sortType = _ref24.sortType;

    commit('setSortType', { categoryId: categoryId, sortType: sortType });
  }
});
// CONCATENATED MODULE: ./src/store/getters.js



/* harmony default export */ var store_getters = ({
  selection: function selection(state) {
    return state.categories.map(function (category) {
      var selectedNominee = state.selected.find(function (_ref) {
        var categoryId = _ref.categoryId;
        return categoryId === category.id;
      });

      return {
        category: category,
        nominee: selectedNominee ? state.nominees.find(function (nominee) {
          return nominee.id === selectedNominee.nomineeId;
        }) : null,
        suggestion: selectedNominee && typeof selectedNominee.suggestionName !== 'undefined' ? selectedNominee : null
      };
    });
  },

  getNomineesByCategoryId: function getNomineesByCategoryId(state, getters) {
    return function (categoryIds) {
      return state.nominees.filter(function (_ref2) {
        var categoryId = _ref2.categoryId;
        return categoryId === categoryIds;
      }).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    };
  },

  getFilteredNomineesByCategoryId: function getFilteredNomineesByCategoryId(state, getters) {
    return function (categoryId) {
      var category = state.categories.find(function (_ref3) {
        var id = _ref3.id;
        return id === categoryId;
      });

      var keyword = category.keyword.trim();

      var filtered = getters.getNomineesByCategoryId(categoryId);
      if (keyword.length) {
        filtered = filtered.filter(function (_ref4) {
          var name = _ref4.name;
          return name.toLowerCase().indexOf(keyword.toLowerCase()) > -1;
        });
      }

      var selectedDayPartId = category.selectedDayPartId,
          selectedChannelId = category.selectedChannelId;


      if (typeof selectedDayPartId === 'number') {
        filtered = filtered.filter(function (_ref5) {
          var showtimes = _ref5.showtimes;

          return showtimes.some(function (tag) {
            return parseInt(parseInt(keys_default()(tag)[0])) === selectedDayPartId;
          });
        });
      }

      if (typeof selectedChannelId === 'string') {
        filtered = filtered.filter(function (_ref6) {
          var stations = _ref6.stations;

          return stations.some(function (tag) {
            return tag === selectedChannelId;
          });
        });
      }

      var sortType = category.sortType;


      if (sortType === SORT_ASC) {
        return filtered;
      }

      if (sortType === SORT_DESC) {
        return filtered.reverse();
      }

      return filtered.sort(function (a, b) {
        return 0.5 - Math.random();
      });
    };
  }
});
// CONCATENATED MODULE: ./src/store/mutations.js
/* harmony default export */ var mutations = ({
  setLoaded: function setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  setAllowSuggestions: function setAllowSuggestions(state, allowSuggestions) {
    state.allowSuggestions = allowSuggestions;
  },
  setOffline: function setOffline(state, offline) {
    state.offline = offline;
  },
  setNominees: function setNominees(state, nominees) {
    state.nominees = nominees;
  },
  setCategories: function setCategories(state, categories) {
    state.categories = categories;
  },
  setFrontend: function setFrontend(state, frontend) {
    state.frontend = frontend;
  },
  setRounds: function setRounds(state, rounds) {
    state.rounds = rounds;
  },
  setShowtimesTags: function setShowtimesTags(state, showtimesTags) {
    state.showtimesTags = showtimesTags;
  },
  setStationsTags: function setStationsTags(state, stationsTags) {
    state.stationsTags = stationsTags;
  },
  selectNominee: function selectNominee(state, _ref) {
    var categoryId = _ref.categoryId,
        nomineeId = _ref.nomineeId;

    var cleared = state.selected.filter(function (choice) {
      return !(choice.categoryId === categoryId);
    });

    state.selected = cleared.concat([{ categoryId: categoryId, nomineeId: nomineeId }]);
  },
  addSuggestion: function addSuggestion(state, _ref2) {
    var categoryId = _ref2.categoryId,
        suggestionName = _ref2.suggestionName,
        _ref2$suggestionStati = _ref2.suggestionStation,
        suggestionStation = _ref2$suggestionStati === undefined ? '-' : _ref2$suggestionStati;

    var cleared = state.selected.filter(function (choice) {
      return !(choice.categoryId === categoryId);
    });

    state.selected = cleared.concat([{ categoryId: categoryId, suggestionName: suggestionName, suggestionStation: suggestionStation }]);
  },
  clearCategory: function clearCategory(state, _ref3) {
    var categoryId = _ref3.categoryId;

    state.selected = state.selected.filter(function (choice) {
      return !(choice.categoryId === categoryId);
    });
  },
  clearSelected: function clearSelected(state) {
    state.selected = [];
  },
  setSelectedChannelId: function setSelectedChannelId(state, _ref4) {
    var categoryId = _ref4.categoryId,
        tagId = _ref4.tagId;

    var category = state.categories.find(function (_ref5) {
      var id = _ref5.id;
      return id === categoryId;
    });

    category.selectedChannelId = category.selectedChannelId === tagId ? null : tagId;
  },
  setSelectedDayPartId: function setSelectedDayPartId(state, _ref6) {
    var categoryId = _ref6.categoryId,
        tagId = _ref6.tagId;

    var category = state.categories.find(function (_ref7) {
      var id = _ref7.id;
      return id === categoryId;
    });

    category.selectedDayPartId = category.selectedDayPartId === tagId ? null : tagId;
  },
  setKeyword: function setKeyword(state, _ref8) {
    var categoryId = _ref8.categoryId,
        keyword = _ref8.keyword;

    var category = state.categories.find(function (_ref9) {
      var id = _ref9.id;
      return id === categoryId;
    });

    category.keyword = keyword;
  },
  setSortType: function setSortType(state, _ref10) {
    var categoryId = _ref10.categoryId,
        sortType = _ref10.sortType;

    var category = state.categories.find(function (_ref11) {
      var id = _ref11.id;
      return id === categoryId;
    });

    category.sortType = sortType;
  }
});
// CONCATENATED MODULE: ./src/store/index.js







vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
  state: {
    loaded: false,
    allowSuggestions: false,
    offline: undefined,
    frontend: [],
    rounds: [],
    categories: [],
    nominees: [],
    selected: [],
    votes: [],
    showtimesTags: ['ochtend', 'middag', 'avond', 'nacht', 'weekend'],
    stationsTags: []
  },
  actions: actions,
  getters: store_getters,
  mutations: mutations
});

/* harmony default export */ var src_store = (store);
// CONCATENATED MODULE: ./src/main.js





























/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: src_router,
  store: src_store,
  render: function render(h) {
    return h(src_App);
  }
});

/***/ }),

/***/ "OHVl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4k7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Su43":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YI7j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dNEa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mYAJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pb+Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pz9T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r/Sp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tYzW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xsZ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yg31":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/main.6d2f34b2613bd29fa588.js